import { createAction, props } from '@ngrx/store';
import {
  PayloadAnagrafica,
  ResponseAggiuntaAnagrafica,
  ResponseAnagraphicManagement,
} from '../../interfaces/response-anagraphic-management';
import { ResponseReteTerzaDettaglio } from '../../interfaces/response-rete-terza-dettaglio';
import {
  RetrieveInterfaceMonitoringCrm,
  RetrieveInterfaceMonitoringSap,
  RetrieveInterfaceMonitoringDashboard,
} from '../../interfaces/retrieve-interface-monitoring';
import { ResponseInterfaceMonitoringSap } from '../../interfaces/response-interface-monitoring-sap';
import { ResponseInterfaceMonitoringCrm } from '../../interfaces/response-interface-monitoring-crm';
import { ResponseInterfaceMonitoringDashboard } from '../../interfaces/response-interface-monitoring-dashboard';
import { PayloadRetrieveDocuments } from '../../interfaces/retrieve-documents';
import { ResponseDocuments } from '../../interfaces/response-documents';
import {
  PayloadStoricoOperazioni,
  ResponseStoricoOperazioni,
} from '../../interfaces/response-operation-history';
import {
  PayloadCrm,
  PayloadSap,
  ResponseCRMO,
  ResponseSAP,
  ResponseDashboard,
  PayloadDashboard,
} from '../../interfaces/response-monitoring-interface';
import {
  ResponseInterfaceHistoryCrm,
  RetrieveInterfaceHistoryCrm,
} from '../../interfaces/response-interface-history-crm';
import {
  ICollectPointPuntoPoste,
  IPayloadtemplatePuntoPoste,
} from '../../interfaces/anagraphic-new-operation';
import { ResponseOperazioniProgressivo } from '../../interfaces/response-operation-progressive';
import {
  IPayloadCd,
  IPayloadRam,
  IResponseCd,
  IResponseMal,
  IResponseRam,
} from '../../interfaces/mal-ram-cd';
import {
  IPayloadCambioStato,
  IResponseCambioStato,
  IResponseCambioStatoPps,
  IResponseListaGestionePunti,
  ISingleObjectGestionePunti,
} from '../../interfaces/points-management';
import {
  IPayloadConfermaCaricamentoAttivazioneMassiva,
  IResponseConfermaCaricamentoAttivazioneMassiva,
  IResponseUploadAttivazioneMassiva,
} from '../../interfaces/attivazione-massiva';
import { RetrieveGestionPuntoPoste } from '../../interfaces/retrieve-gestione-puntoposte';
import {
  PayloadCP,
  ResponseCMP,
  ResponseCP,
} from '../../interfaces/puntoposte-detail';
import {
  IPayloadReportGiacenzeXls,
  IResponseReportGiacenzeList,
} from '../../interfaces/report-giacenze';
import {
  IPayloadStoricoSap,
  IResponseStoricoSap,
} from '../../interfaces/response-interface-history-sap';
import { IAnagraphicState } from './anagraphic';
import { IPayloadReportGiacenzeLockerXls, IResponseReportGiacenzeLockerList } from '../../interfaces/report-giacenze-locker';
import { IPayloadStoricoDashboard, IResponseStoricoDashboard } from '../../interfaces/response-interface-history-dashboard';
import {
  IPayloadStoricoIcon,
  IResponseStoricoIcon,
} from '../../interfaces/monitoraggio-storico-icon';
import { IPayloadConfermaCaricamentoPreAttivazione, IResponseConfermaCaricamentoPreAttivazione, IResponseUploadPreAttivazione } from '../../interfaces/forzatura-preattivazione';

export const RETRIEVE_ANAGRAPHIC = createAction(
  '[REPORT ANAGRAFICA] - retrieve anagraphic'
);

export const RETRIEVE_ANAGRAPHIC_SUCCESS = createAction(
  '[REPORT ANAGRAFICA] - retrieve anagraphic success',
  props<{ responseAnagrafica: ResponseAnagraphicManagement }>()
);

export const RETRIEVE_ADD_ANAGRAPHIC = createAction(
  '[REPORT ANAGRAFICA] - retrieve add anagraphic',
  props<{ payload: PayloadAnagrafica }>()
);

export const RETRIEVE_ADD_ANAGRAPHIC_SUCCESS = createAction(
  '[REPORT ANAGRAFICA] - retrieve add anagraphic success',
  props<{ responseAggiuntaAnagrafica: ResponseAggiuntaAnagrafica }>()
);

export const RETRIEVE_INTERFACE_MONITORING_CRM = createAction(
  '[ANAGRAFICA] - retrieve interface monitoring CRM',
  props<{ payload: RetrieveInterfaceMonitoringCrm }>()
);

export const RETRIEVE_INTERFACE_MONITORING_SAP = createAction(
  '[ANAGRAFICA] - retrieve interface monitoring SAP',
  props<{ payload: RetrieveInterfaceMonitoringSap }>()
);

export const RETRIEVE_INTERFACE_MONITORING_DASHBOARD = createAction(
  '[ANAGRAFICA] - retrieve interface monitoring DASHBOARD',
  props<{ payload: RetrieveInterfaceMonitoringDashboard }>()
);

export const RETRIEVE_INTERFACE_MONITORING_SUCCESS = createAction(
  '[ANAGRAFICA] - retrieve interface monitoring success',
  props<{
    responseInterfaceMonitoring:
      | ResponseInterfaceMonitoringCrm
      | ResponseInterfaceMonitoringSap
      | ResponseInterfaceMonitoringDashboard
      | null;
  }>()
);

export const RETRIEVE_THIRD_NETWORK_DETAIL = createAction(
  '[DETTAGLIO RETE TERZA] - retrieve third network detail',
  props<{ payload: string }>()
);

export const RETRIEVE_THIRD_NETWORK_DETAIL_SUCCESS = createAction(
  '[DETTAGLIO RETE TERZA] - retrieve third network detail success',
  props<{ responseReteTerzaDettaglio: ResponseReteTerzaDettaglio }>()
);

export const EDIT_THIRD_NETWORK_DETAIL = createAction(
  '[DETTAGLIO RETE TERZA] - edit third network detail',
  props<{ payload: PayloadAnagrafica }>()
);

export const RETRIEVE_DOCUMENTS = createAction(
  '[DOCUMENTI] - recupero documenti',
  props<{ payload: PayloadRetrieveDocuments }>()
);

export const RETRIEVE_DOCUMENTS_SUCCESS = createAction(
  '[DOCUMENTI] - recupero documenti success',
  props<{ responseDocuments: ResponseDocuments | null }>()
);

export const EDIT_THIRD_NETWORK_DETAIL_SUCCESS = createAction(
  '[DETTAGLIO RETE TERZA] - edit third network detail success',
  props<{
    responseModificaReteTerzaDettaglio: ResponseAggiuntaAnagrafica | null;
  }>()
);

export const SET_CURRENT_SIGLA_RETE = createAction(
  '[REPORT ANAGRAFICA] - set current sigla rete',
  props<{ currentSiglaRete: string | null }>()
);

export const RETRIEVE_CRMO_DETAIL = createAction(
  '[DETTAGLIO CRMO] - retrieve crmo detail',
  props<{ idOperazione: string }>()
);

export const RETRIEVE_CRMO_DETAIL_SUCCESS = createAction(
  '[DETTAGLIO CRMO] - retrieve crmo detail success',
  props<{ responseCrmo: ResponseCRMO | null }>()
);

export const RETRIEVE_RISOTTOMETTI_CRMO = createAction(
  '[RISOTTOMETTI CRMO] - retrieve risottometti crm',
  props<{ payload: PayloadCrm }>()
);

export const RETRIEVE_RISOTTOMETTI_CRMO_ERROR = createAction(
  '[RISOTTOMETTI CRMO] - retrieve risottometti crm error',
  props<{ responseRisottomettiCrm: ResponseCRMO }>()
);

export const RETRIEVE_OPERATION_HISTORY = createAction(
  '[STORICO] - retrieve operation history',
  props<{ payload: PayloadStoricoOperazioni }>()
);

export const RETRIEVE_OPERATION_HISTORY_SUCCESS = createAction(
  '[STORICO] - retrieve operation history success',
  props<{ responseStoricoOperazioni: ResponseStoricoOperazioni | null }>()
);

export const RETRIEVE_SAP_DETAIL = createAction(
  '[DETTAGLIO SAP] - retrieve sap detail',
  props<{ idOperazione: string }>()
);

export const RETRIEVE_DASHBOARD_DETAIL = createAction(
  '[DETTAGLIO DASHBOARD] - retrieve dashboard detail',
  props<{ idOperazione: string }>()
);

export const RETRIEVE_DASHBOARD_DETAIL_SUCCESS = createAction(
  '[DETTAGLIO DASHBOARD] - retrieve dashboard detail success',
  props<{ responseDashboard: ResponseDashboard | null }>()
);

export const RETRIEVE_SAP_DETAIL_SUCCESS = createAction(
  '[DETTAGLIO SAP ] - retrieve sap detail success',
  props<{ responseSap: ResponseSAP | null }>()
);

export const RETRIEVE_RISOTTOMETTI_SAP = createAction(
  '[RISOTTOMETTI SAP ] - retrieve risottometti sap',
  props<{ payload: PayloadSap }>()
);

export const RETRIEVE_RISOTTOMETTI_SAP_ERROR = createAction(
  '[RISOTTOMETTI SAP ] - retrieve risottometti sap error',
  props<{ responseRisottomettiSap: ResponseSAP }>()
);

export const RETRIEVE_RISOTTOMETTI_DASHBOARD = createAction(
  '[RISOTTOMETTI DASHBOARD ] - retrieve risottometti dashboard',
  props<{ payload: PayloadDashboard }>()
);

export const RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR = createAction(
  '[RISOTTOMETTI DASHBOARD ] - retrieve risottometti dashboard error',
  props<{ responseRisottomettiDashboard: ResponseDashboard | null}>()
);

export const RETRIEVE_INTERFACE_HISTORY_CRM = createAction(
  '[ANAGRAFICA] - retrieve interface history CRM',
  props<{ payload: RetrieveInterfaceHistoryCrm }>()
);

export const RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS = createAction(
  '[ANAGRAFICA] - retrieve interface history CRM success',
  props<{ responseInterfaceHistory: ResponseInterfaceHistoryCrm | null }>()
);

export const RETRIEVE_INTERFACE_HISTORY_SAP = createAction(
  '[ANAGRAFICA] - retrieve interface history SAP',
  props<{ payload: IPayloadStoricoSap }>()
);

export const RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS = createAction(
  '[ANAGRAFICA] - retrieve interface history SAP success',
  props<{ responseStoricoSap: IResponseStoricoSap | null }>()
);

export const RETRIEVE_INTERFACE_HISTORY_DASHBOARD = createAction(
  '[ANAGRAFICA] - retrieve interface history DASHBOARD',
  props<{ payload: IPayloadStoricoDashboard }>()
);

export const RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS = createAction(
  '[ANAGRAFICA] - retrieve interface history DASHBOARD success',
  props<{ responseStoricoDashboard: IResponseStoricoDashboard | null }>()
);

export const DOWNLOAD_TEMPLATE_PRECOMPILED = createAction(
  '[NUOVA OPERAZIONE] - download template nuova operazione precompilato',
  props<{
    payload: IPayloadtemplatePuntoPoste;
    idOperazione: string;
    reteTerza: string;
    progressiveValue: string;
  }>()
);

export const RETRIEVE_OPERATION_PROGRESSIVE = createAction(
  '[OPERAZIONI] - retrieve operation progressive'
);

export const RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS = createAction(
  '[OPERAZIONI] - retrieve operation progressive success',
  props<{
    responseOperazioniProgressivo: ResponseOperazioniProgressivo | null;
  }>()
);

export const UPLOAD_FILE_NEW_OPERATION = createAction(
  '[NUOVA OPERAZIONE] - upoaf file nuova operazione',
  props<{
    payload: any;
    idOperazione: string;
    reteTerza: string;
    isPut: boolean;
  }>()
);

export const UPLOAD_FILE_NEW_OPERATION_SUCCESS = createAction(
  '[NUOVA OPERAZIONE] - upoaf file nuova operazione success',
  props<{ responseNuovaOperazioneFile: any }>()
);

export const RETRIEVE_MAL = createAction('[NUOVA OPERAZIONE] - retrieve mal');

export const RETRIEVE_MAL_SUCCESS = createAction(
  '[NUOVA OPERAZIONE] - retrieve mal success',
  props<{ responseMal: IResponseMal }>()
);

export const RETRIEVE_RAM = createAction(
  '[NUOVA OPERAZIONE] - retrieve ram',
  props<{ payload?: IPayloadRam }>()
);

export const RETRIEVE_RAM_SUCCESS = createAction(
  '[NUOVA OPERAZIONE] - retrieve ram success',
  props<{ responseRam: IResponseRam }>()
);

export const RETRIEVE_CD = createAction(
  '[NUOVA OPERAZIONE] - retrieve cd',
  props<{ payload?: IPayloadCd }>()
);

export const RETRIEVE_CD_SUCCESS = createAction(
  '[NUOVA OPERAZIONE] - retrieve cd success',
  props<{ responseCd: IResponseCd }>()
);

export const RETRIEVE_POINTS_LIST = createAction(
  '[GESTIONE PUNTI] - retrieve points list',
  props<{ payload: ICollectPointPuntoPoste }>()
);

export const RETRIEVE_POINTS_LIST_SUCCESS = createAction(
  '[GESTIONE PUNTI] - retrieve points list success',
  props<{ responseListaGestionePunti: IResponseListaGestionePunti | null }>()
);

export const DOWNLOAD_REPORT_POINTS_MANAGEMENT = createAction(
  '[GESTIONE PUNTI] - download report gestione punti',
  props<{ payload: ISingleObjectGestionePunti[]; isApt: boolean }>()
);

export const CHANGE_STATUS = createAction(
  '[GESTIONE PUNTI] - cambio stato punto poste',
  props<{ payload: IPayloadCambioStato }>()
);

export const CHANGE_STATUS_SUCCESS = createAction(
  '[GESTIONE PUNTI] - cambio stato punto poste success',
  props<{
    responseCambioStatoWithPayload: {
      responseCambioStato: IResponseCambioStato;
      payload: IPayloadCambioStato;
    } | null;
  }>()
);

export const CHANGE_STATUS_PPS = createAction(
  '[GESTIONE PUNTI] - cambio stato punto poste pps',
  props<{ payload: IPayloadCambioStato }>()
);

export const CHANGE_STATUS_PPS_SUCCESS = createAction(
  '[GESTIONE PUNTI] - cambio stato punto poste success pps',
  props<{
    responseCambioStatoPpsWithPayload: {
      responseCambioStato: IResponseCambioStatoPps;
      payload: IPayloadCambioStato;
    } | null;
  }>()
);

export const DOWNLOAD_MASSIVE_ACTIVATION_PRECOMPILED = createAction(
  '[ATTIVAZIONE MASSIVA] - download attivazione massiva precompilato',
  props<{ payload: { action4: string }; reteTerza: string }>()
);

export const DOWNLOAD_MASSIVE_PRE_ACTIVATION_PRECOMPILED = createAction(
  '[PREATTIVAZIONE MASSIVA] - download preattivazione massiva precompilato',
  props<{ payload: { action4: string }; reteTerza: string }>()
);

export const UPLOAD_FILE_MASSIVE_ACTIVATION = createAction(
  '[ATTIVAZIONE MASSIVA] - upload file attivazione massiva',
  props<{ payload: FormData }>()
);

export const UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS = createAction(
  '[ATTIVAZIONE MASSIVA] - upload file attivazione massiva success',
  props<{
    responseAttivazioneMassivaFile: IResponseUploadAttivazioneMassiva | null;
  }>()
);

export const CONFIRM_FILE_MASSIVE_ACTIVATION = createAction(
  '[ATTIVAZIONE MASSIVA] - confirm file attivazione massiva',
  props<{ payload: IPayloadConfermaCaricamentoAttivazioneMassiva }>()
);

export const CONFIRM_FILE_MASSIVE_ACTIVATION_SUCCESS = createAction(
  '[ATTIVAZIONE MASSIVA] - confirm file attivazione massiva success',
  props<{
    responseConfermaAttivazioneMassivaFile: IResponseConfermaCaricamentoAttivazioneMassiva;
  }>()
);

export const DOWNLOAD_PREACTIVATION_PRECOMPILED = createAction(
  '[FORZATURA PREATTIVAZIONE] - download forzatura preattivazione precompilato',
  props<{ payload: { action4: string }; reteTerza: string }>()
);

export const UPLOAD_FILE_PREACTIVATION = createAction(
  '[FORZATURA PREATTIVAZIONE] - upload file forzatura preattivazione',
  props<{ payload: FormData }>()
);

export const UPLOAD_FILE_PREACTIVATION_SUCCESS = createAction(
  '[FORZATURA PREATTIVAZIONE] - upload file forzatura preattivazione success',
  props<{
    responsePreAttivazioneFile: IResponseUploadPreAttivazione | null;
  }>()
);

export const CONFIRM_FILE_PREACTIVATION = createAction(
  '[FORZATURA PREATTIVAZIONE] - confirm file forzatura preattivazione',
  props<{ payload: IPayloadConfermaCaricamentoPreAttivazione }>()
);

export const CONFIRM_FILE_PREACTIVATION_SUCCESS = createAction(
  '[FORZATURA PREATTIVAZIONE] - confirm file forzatura preattivazione success',
  props<{
    responseConfermaPreAttivazioneFile: IResponseConfermaCaricamentoPreAttivazione;
  }>()
);

export const RETRIEVE_GESTIONE_PUNTOPOSTE = createAction(
  '[DETTAGLIO PUNTOPOSTE] - retrieve puntoposte detail',
  props<{ idPuntoPoste?: string }>()
);

export const RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS = createAction(
  '[DETTAGLIO PUNTOPOSTE] - retrieve puntoposte detail success',
  props<{ responsePuntoPoste: RetrieveGestionPuntoPoste | null }>()
);

export const RETRIEVE_CMP_LIST = createAction(
  '[LISTA CMP] - retrieve cmp list'
);

export const RETRIEVE_CMP_LIST_SUCCESS = createAction(
  '[LISTA CMP] - retrieve cmp list success',
  props<{ responseCMP: ResponseCMP }>()
);

export const RETRIEVE_AUDIT = createAction(
  '[AUDIT XLS] - download audit',
  props<{ idPuntoPoste: string }>()
);

export const RETRIEVE_CP = createAction(
  '[CP] - retrieve cp',
  props<{ payload: PayloadCP }>()
);

export const RETRIEVE_CP_SUCCESS = createAction(
  '[CP] - retrieve cp success',
  props<{ responseCP: ResponseCP | null }>()
);

export const RETRIEVE_REPORT_GIACENZE_LIST = createAction(
  '[REPORT GIACENZE] - retrieve report giacenze list',
  props<{ idPuntoPoste: string }>()
);

export const RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS = createAction(
  '[REPORT GIACENZE] - retrieve report giacenze list success',
  props<{ responseReportGiacenzeList?: IResponseReportGiacenzeList }>()
);

export const RETRIEVE_REPORT_GIACENZE_XLS = createAction(
  '[REPORT GIACENZE] - retrieve report giacenze XLS',
  props<{ payload: IPayloadReportGiacenzeXls }>()
);

export const RETRIEVE_REPORT_GIACENZE_LOCKER_LIST = createAction(
  '[REPORT GIACENZE LOCKER] - retrieve report giacenze locker list',
  props<{ idPuntoPosteLocker: string }>()
);

export const RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS = createAction(
  '[REPORT GIACENZE LOCKER] - retrieve report giacenze locker list success',
  props<{ responseReportGiacenzeLockerList: IResponseReportGiacenzeLockerList | null }>()
);

export const RETRIEVE_REPORT_GIACENZE_LOCKER_XLS = createAction(
  '[REPORT GIACENZE LOCKER] - retrieve report giacenze locker XLS',
  props<{ payload: IPayloadReportGiacenzeLockerXls }>()
);

export const DOWNLOAD_MIG2 = createAction(
  '[GESTIONE PUNTI] - download mig2',
  props<{ payload: any }>()
);

export const RESET_ANAGRAPHIC_STORE = createAction(
  '[ANAGRAFICA] - reset anagraphic store'
);

export const RETRIEVE_STORICO_ICON = createAction(
  '[ANAGRAFICA] - retrieve storico icon',
  props<{ payload: IPayloadStoricoIcon }>()
);

export const RETRIEVE_STORICO_ICON_SUCCESS = createAction(
  '[ANAGRAFICA] - retrieve storico icon success',
  props<{ responseStoricoIcon: IResponseStoricoIcon }>()
);
